import React from 'react';
import {
  BarChart, Bar, PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF'];

const dummyData = {
  analyticsData: [
    { name: 'Jan', Impressions: 4000, Clicks: 2400 },
    { name: 'Feb', Impressions: 3000, Clicks: 1398 },
    { name: 'Mar', Impressions: 5000, Clicks: 2908 },
    { name: 'Apr', Impressions: 2780, Clicks: 2000 },
    { name: 'May', Impressions: 6000, Clicks: 4000 },
  ],
  audienceDemographics: [
    { name: '18-24', value: 400 },
    { name: '25-34', value: 600 },
    { name: '35-44', value: 300 },
    { name: '45-54', value: 200 },
    { name: '55+', value: 100 },
  ],
  campaignPerformance: [
    { name: 'Launch Campaign', impressions: 5000, clicks: 320, ctr: '6.4%' },
    { name: 'Spring Promo', impressions: 3200, clicks: 200, ctr: '6.25%' },
    { name: 'Brand Awareness', impressions: 7000, clicks: 400, ctr: '5.71%' },
  ]
};

const AnalyticsPage = () => {
  const data = dummyData;

  return (
    <section className="analytics-section">
      <div className="analytics-grid">
        <div className="analytics-card">
          <h3 className="card-title">Monthly Performance Metrics</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data.analyticsData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Impressions" fill="#8884d8" radius={[10, 10, 0, 0]} />
              <Bar dataKey="Clicks" fill="#82ca9d" radius={[10, 10, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="analytics-card">
          <h3 className="card-title">Audience Demographics (Age)</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={data.audienceDemographics}
                cx="50%"
                cy="50%"
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
              >
                {data.audienceDemographics.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="analytics-card full-width">
        <h3 className="card-title">Campaign Performance Overview</h3>
        <div className="table-wrapper">
          <table className="analytics-table">
            <thead>
              <tr>
                <th>Campaign Name</th>
                <th>Impressions</th>
                <th>Clicks</th>
                <th>CTR</th>
              </tr>
            </thead>
            <tbody>
              {data.campaignPerformance.map((row, index) => (
                <tr key={index}>
                  <td>{row.name}</td>
                  <td>{row.impressions}</td>
                  <td>{row.clicks}</td>
                  <td>{row.ctr}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default AnalyticsPage;
